import { ReactNode, useEffect } from 'react';
import { useAuthStore } from '@/features/auth/store/authStore';
import { api } from '@/shared/services/apiClient';

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const { token, initialize, clearAuth } = useAuthStore();

  useEffect(() => {
    // Set the auth token in the API client if it exists
    if (token) {
      api.setAuth(token);
    }
    
    // Mark auth as initialized
    initialize();
  }, [token, initialize]);

  // Set up auth token interceptor
  useEffect(() => {
    const checkAuthStatus = () => {
      const storedToken = localStorage.getItem('civista_auth_token');
      if (!storedToken && token) {
        // Token was removed externally, clear auth
        clearAuth();
      }
    };

    // Check auth status on storage changes
    window.addEventListener('storage', checkAuthStatus);
    
    return () => {
      window.removeEventListener('storage', checkAuthStatus);
    };
  }, [token, clearAuth]);

  return <>{children}</>;
};